<template>
  <nav-bar title="报警器管理" />
  <Content :bottom="showLoading ? 0 : 76">
    <Loading v-if="showLoading" :isLoading="isLoading" @reload="getData" />
    <ul class="list">
      <li class="list-item" v-for="item in list" :key="item.id">
        <div class="list-item__code">设备ID：{{ item.eqId }}</div>
        <div class="list-item__address">所在位置：{{ item.eqPosition }}</div>
        <van-row gutter="16">
          <van-col span="12">
            <van-button
              block
              size="small"
              type="primary"
              native-type="button"
              @click="alarmDetailRef.showPopup(item)"
            >
              详细
            </van-button>
          </van-col>
          <van-col span="12">
            <van-button
              block
              size="small"
              type="danger"
              :loading="delLoading && currId === item.id"
              loading-text="请稍后..."
              :disabled="delLoading && currId === item.id"
              native-type="button"
              @click="handleDelClick(item.id)"
            >
              删除
            </van-button>
          </van-col>
        </van-row>
      </li>
    </ul>
    <empty v-if="!list.length" />
  </Content>
  <div class="btn-conatiner van-hairline--top" v-if="!showLoading">
    <van-button
      block
      type="primary"
      native-type="button"
      @click="addAlarmRef.showPopup(userId)"
    >
      新增报警器
    </van-button>
  </div>
  <alarm-detail ref="alarmDetailRef" />
  <add-alarm ref="addAlarmRef" @add-alarm="getData" />
</template>

<script>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { getCustomerAlarmStatus, deleteAlarm } from '@/api/customer'
import AlarmDetail from './components/AlarmDetail'
import AddAlarm from './components/AddAlarm'
export default {
  name: 'AlarmManagement',
  components: {
    AlarmDetail,
    AddAlarm
  },
  setup() {
    const store = useStore()
    const userId = computed(() => store.state.roleInfo.companyId)
    const isLoading = ref(true)
    const showLoading = ref(true)
    const list = ref([])
    // 获取报警器列表
    const getData = async () => {
      try {
        isLoading.value = true
        showLoading.value = true
        const { data } = await getCustomerAlarmStatus({ userId: userId.value })
        list.value = data
        isLoading.value = false
        showLoading.value = false
      } catch {
        isLoading.value = false
        showLoading.value = true
      }
    }
    getData()

    // 删除报警器
    const alarmDetailRef = ref(null)
    const delLoading = ref(false)
    const currId = ref('')
    const handleDelClick = async (id) => {
      currId.value = id
      delLoading.value = true
      try {
        await deleteAlarm(id)
        list.value = list.value.filter((item) => item.id !== id)
      } catch {
        delLoading.value = false
      }
    }
    const addAlarmRef = ref(null)

    return {
      list,
      getData,
      isLoading,
      showLoading,
      alarmDetailRef,
      delLoading,
      handleDelClick,
      currId,
      addAlarmRef,
      userId
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-conatiner {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
}
.list {
  padding: 16px;
  font-size: 12px;
  line-height: 22px;
  .list-item {
    padding: 14px;
    background-color: #fff;
    box-shadow: rgba(87, 107, 146, 0.25) 0px 4px 8px -2px,
      rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
    margin-bottom: 16px;
  }
}
</style>
